import HomeIcon from 'assets/icons/menu/home.svg';
import ReportIcon from 'assets/icons/menu/reports.svg';
import TrafficIcon from 'assets/icons/menu/traffic.svg';
import BookingIcon from 'assets/icons/menu/bookings.svg';
import PaymentIcon from 'assets/icons/menu/cash-register-solid.svg';
import UserIcon from 'assets/icons/menu/users-svgrepo-com.svg';
import ExperiencerIcon from 'assets/icons/menu/person-hiking-solid.svg';
import HostIcon from 'assets/icons/menu/building-user-solid.svg';
import ExperiencesIcon from 'assets/icons/menu/backpack.svg';
import BundleIcon from 'assets/icons/menu/gift-svgrepo-com.svg';
import ResourceIcon from 'assets/icons/menu/resource.svg';
import InsuranceIcon from 'assets/icons/menu/insurance.svg';
import ContractIcon from 'assets/icons/menu/handshake-svgrepo-com.svg';
import DiscountIcon from 'assets/icons/percentage.svg';
import MarkupIcon from 'assets/icons/menu/markups.svg';
import PriceIcon from 'assets/icons/menu/price.svg';
import CostIcon from 'assets/icons/menu/cost.svg';
import CurrencyIcon from 'assets/icons/menu/currency.svg';

export const sections = [
    {
        title: 'layout.menu.dashboard',
        items: [
            {
                label: 'layout.menu.dashboard',
                path: '/home',
                icon: HomeIcon,
            },
            {
                label: 'layout.menu.reports',
                path: '/report',
                icon: ReportIcon,
            },
            {
                label: 'layout.menu.traffic',
                path: '/traffic',
                icon: TrafficIcon,
            },
            {
                label: 'layout.menu.bookings',
                path: '/booking',
                icon: BookingIcon,
            },
            {
                label: 'layout.menu.payments',
                path: '/payment',
                icon: PaymentIcon,
            },
        ],
    },
    {
        title: 'layout.menu.users',
        items: [
            {
                label: 'layout.menu.users',
                path: '/user',
                icon: UserIcon,
            },
            {
                label: 'layout.menu.tour_operators',
                path: '/experiencer',
                icon: ExperiencerIcon,
            },
            {
                label: 'layout.menu.hosts',
                path: '/host',
                icon: HostIcon,
            },
        ],
    },
    {
        title: 'layout.menu.products',
        items: [
            {
                label: 'layout.menu.experiences',
                path: '/experience',
                icon: ExperiencesIcon,
            },
            {
                label: 'layout.menu.bundles',
                path: '/bundle',
                icon: BundleIcon,
            },
            {
                label: 'layout.menu.resources',
                path: '/resource',
                icon: ResourceIcon,
            },
            {
                label: 'layout.menu.insurances',
                path: '/insuranceProvider',
                icon: InsuranceIcon,
            },
        ],
    },
    {
        title: 'layout.menu.business',
        items: [
            {
                label: 'layout.menu.contracts',
                path: '/contract',
                icon: ContractIcon,
            },
            {
                label: 'layout.menu.discounts',
                path: '/discount',
                icon: DiscountIcon,
            },
            {
                label: 'layout.menu.markups',
                path: '/markup',
                icon: MarkupIcon,
            },
            {
                label: 'layout.menu.prices',
                path: '/price',
                icon: PriceIcon,
            },
            {
                label: 'layout.menu.costs',
                path: '/cost',
                icon: CostIcon,
            },
            {
                label: 'layout.menu.currencies',
                path: '/currency',
                icon: CurrencyIcon,
            },
        ],
    },
];
